import { motion } from "framer-motion";
import { Phone, FileText, Camera, Building2, CalendarCheck } from "lucide-react";

const POINTS = [
  {
    icon: Phone,
    title: "One point of contact",
    text: "One call, one coordinator — no chasing multiple contractors.",
  },
  {
    icon: FileText,
    title: "Clear estimates before work begins",
    text: "Every quote is confirmed with you before any work starts.",
  },
  {
    icon: Camera,
    title: "Photo-documented updates",
    text: "Before-and-after photos so you can see exactly what was done.",
  },
  {
    icon: Building2,
    title: "Residential and commercial service",
    text: "Homes, rentals, offices, and retail spaces alike.",
  },
  {
    icon: CalendarCheck,
    title: "Dependable scheduling",
    text: "Booked arrival windows you can plan around, confirmed in writing.",
  },
];

export const WhyChoose = () => {
  return (
    <section id="why-us" className="border-y border-white/10 bg-[#12141C] py-16 sm:py-24 lg:py-32" data-testid="why-choose-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-jbmono text-xs sm:text-sm uppercase tracking-[0.25em] text-[#FF2A3B] font-semibold" data-testid="why-choose-eyebrow">
            ✦ Why Red Star
          </p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight" data-testid="why-choose-heading">
            Why property owners choose Red Star.
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-testid="why-choose-grid">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-surface rounded-xl p-6 transition-colors hover:border-[#FF2A3B]/40"
              data-testid={`why-point-${i}`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#FF2A3B]/40 bg-[#FF2A3B]/10">
                <p.icon size={18} className="text-[#FF2A3B]" />
              </span>
              <h3 className="mt-5 font-display text-base font-bold tracking-tight leading-snug">
                {p.title}
              </h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
